var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.986,
    height: 13.402,
    viewBox: "0 0 26.986 13.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29047",
    "data-name": "Group 29047",
    transform: "translate(-1285.92 -560.796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51796",
    "data-name": "Path 51796",
    d: "M3220.609,3439l5.994,5.994L3232.6,3439",
    transform: "translate(-2133.503 3794.1) rotate(-90)",
    fill: "none",
    stroke: "#ea555f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51799",
    "data-name": "Path 51799",
    d: "M3295.646,3759.5h-25.571",
    transform: "translate(-1984.155 -3192)",
    fill: "none",
    stroke: "#ea555f",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.43bbd1a5e97d6b1bd4c0ed9674da9ed8.svg";
export { ForwardRef as ReactComponent };